export { default as QuillAdapter } from './Quill';
